<template>
  <cupshe-table
    rowKey="index"
    :dataSource="dataList"
    :columns="columns"
    :pagination="false"
    class="mb20 mt10"
    :scroll="{ y: 'calc(100vh - 190px)' }"
    is-drag
    @dragChange="dragChange"
  >
    <template #deal="{text}">
      <a-button size="small" type="link" @click="() => deleteInfo(text.id)"
        >删除</a-button
      >
      <a-button size="small" type="link" @click="() => show(text)"
        >修改</a-button
      >
      <a-button size="small" type="link" @click="() => menuConfig(text)"
        >菜单配置</a-button
      >
    </template>
  </cupshe-table>

  <EventAlert v-if="visible" />
</template>
<script>
import { toRefs, inject } from 'vue'
import EventAlert from './EventAlert'
import { menu_sort_post } from 'server/modules/351.js'
import { message } from 'ant-design-vue'
export default {
  components: {
    EventAlert
  },
  setup() {
    const state = inject('state')
    const systemState = inject('systemState')
    const dragChange = async data => {
      const result = await menu_sort_post({
        sourceId: data.source.id,
        targetId: data.target.id
      })
      if (result.success) {
        systemState.getSystemList()
      } else {
        message.warn(result.retInfo)
      }
    }
    return {
      dragChange,
      deleteInfo: id => {
        state.deleteItem(id, () => {
          systemState.getSystemList()
        })
      },
      ...toRefs(systemState),
      columns: [
        {
          title: '系统ID',
          dataIndex: 'id',
          key: 'id',
          width: 80
        },
        {
          title: '系统名称',
          dataIndex: 'menuName',
          key: 'menuName',
          width: 100
        },
        {
          title: '系统域名',
          dataIndex: 'menuPath',
          key: 'menuPath',
          width: 200
        },
        {
          title: '系统描述',
          dataIndex: 'menuDesc',
          key: 'menuDesc',
          width: 200
        },
        {
          title: '操作',
          key: 'deal',
          width: 200
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
